import { SppedTestIndex } from "@Src/features/SpeedTest"

export const SpeedTest = () => {

    return (
        <>
         <SppedTestIndex />
        </>
    )
}